<template>
<v-main>
    <div><v-btn @click="getPdf">{{printStr}}</v-btn></div>
    <div class="resingblock">
        <h2 class="resingTitle">{{text.title}}</h2>
        <div class="resingSubBlock">
            <span class="resingCd">{{text.userCd}}<br>{{form.userCode}}</span>
            <span class="resingSimei">{{text.simei}}<br>{{form.userName}}</span>
        </div>
        <div class="resingMainBlock">
            <div class="resingInfoBlock">
                <span class="resingMes1">{{form.messege1}}</span>
                <span class="resingMes2">{{form.messege2}}</span>
            </div>
            <div class="resingDetailBlock">
                <span>{{text.detail}}</span>
                <table class="resingDetailTbl">
                    <tr>
                        <th>{{text.jobClass}}</th>
                        <td class="str">{{form.jobClass}}</td>
                    </tr>
                    <tr>
                        <th>{{text.gobo}}</th>
                        <td class="str">{{form.gobo}}</td>
                    </tr>
                </table>
                <table class="resingDetailTbl">
                    <tr>
                        <th>{{text.base}}</th>
                        <td class="deci">{{form.base}}</td>
                    </tr>
                    <tr>
                        <th>{{text.conti}}</th>
                        <td class="deci">{{form.conti}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="resingSignBlock">
            <span>{{form.singDate}}</span>
            <span class="signName">{{text.singName}}</span>
        </div>
    </div>
</v-main>
</template>

<script lang="ts">
    import Vue from 'vue';
    import lang from "../../lang";
    let text = new lang(0);
    import * as comm from '../../common';
    import {userData} from "../../types";
    import {MyResignSalaryItem} from "../../lib/api/api_response_type";
    import {strReplacePercentObject,getGengou,LoadingOverlay} from "../../common";
    import {apiRequest} from "../../lib/api";

    export default Vue.extend({
        mounted(){
            this.api = this.$store.state.apiSaver;
            this.resinData = this.$store.state.resinData as MyResignSalaryItem;
            const adate = new Date(this.resinData.adateRaw);
            const aGengou = getGengou(adate);
            this.form.userCode = this.resinData.userid;
            this.form.userName = strReplacePercentObject(this.text.namedono,{name:this.resinData.username});
            if(aGengou) this.form.messege1 = strReplacePercentObject(this.text.messege1a,{"gengou":aGengou.name,"year":aGengou.year,"month":(adate.getMonth()+1).toString()});
            this.form.messege2 = strReplacePercentObject(this.text.messege1b,{"yen":this.resinData.baseSal});
            this.form.jobClass = this.resinData.jobLevel;
            this.form.gobo = this.resinData.gobo;
            this.form.base = this.resinData.baseReword+this.text.yen;
            this.form.conti = this.resinData.contiReword+this.text.yen;
            const rdate = new Date(this.resinData.rdateRaw);
            const rGengou = getGengou(rdate);
            if(rGengou) this.form.singDate = strReplacePercentObject(this.text.singDate,{"gengou":rGengou.name,"year":rGengou.year,"month":(rdate.getMonth()+1).toString(),"date":rdate.getDate().toString()});
        },
        data: () => ({
            text : text.Text.resingForm.salary,
            mes : text.Text.messege,
            printStr:text.Text.print,
            resinData:undefined as undefined|MyResignSalaryItem,
            form:{
                userCode:"",
                userName:"",
                messege1:"",
                messege2:"",
                jobClass:"",
                gobo:"",
                base:"",
                conti:"",
                singDate:"",
            },
            api:null as null|{connection:boolean,apiRequest:null|apiRequest},
        }),
        methods:{
            async getPdf(){
                LoadingOverlay(this,true);
                if(this.api && this.api.connection && this.api.apiRequest){
                    const apiResponse = await this.api.apiRequest.request.my.printResinSalary();
                    if(apiResponse.statusCode === 200 && apiResponse.data.pdfdata){
                        LoadingOverlay(this,false);
                        comm.openPdfNewWindow(apiResponse.data.pdfdata.data)
                    }else if(apiResponse.statusCode === 401){
                        comm.invalidSession(this);
                    }else{
                        comm.ApiErrorMessege(this,comm.unknowError);
                    }
                }
            }
        },
    });
</script>

<style scoped>
.resingblock{
    margin: 0.5em 1em;
    padding: 0.5ch;
    border: solid 2px;
}
.resingTitle{
    text-align: center;
}
.resingSubBlock{
    display: flex;
}
.resingCd{
    text-align: center;
    margin-right: 2em;
}
.resingSimei{
    text-align: left;
}
.resingMainBlock{
    margin-top: 2em;
    margin-left: 4em;
}
@media (max-width:640px) {
    .resingMainBlock{
        margin-left: 0;
    }
}
.resingInfoBlock{
    display: flex;
    flex-direction: column;
}
.resingMes1{
    margin: 0;
}
.resingMes2{
    margin-left: 4em;
}
.resingDetailBlock{
    margin-top: 2em;
}
.resingDetailTbl{
    text-align: left;
    margin: 0 0 2ch 5ch;
}
.resingDetailTbl th{
    font-weight: normal;
    padding-right: 2ch;
}
.resingDetailTbl .str{
    text-align: center;
}
.resingDetailTbl .deci{
    text-align: right;
}
.resingSignBlock{
    margin-top: 4ch;
    display: flex;
}
.resingSignBlock .signName{
    margin-left: auto;
}
</style>